export const DOMAIN = "https://policy-fair-mix.web.app";
export const TITLE = "제21회 전국주민자치박람회";
export const EMAIL = "contact@juminexpo.kr";
export const TELEPHONE = "070-8064-3035";
